<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
    
  },

  mounted() {
    window.onresize = this.handleResize;
    this.handleResize();
  },
  methods: {
    handleResize() {
      const clientWidth = document.body.clientWidth;
      const pathType = window.location.pathname.split("/")[1];
      let isH5 = pathType === "h5";
      let h5 = window.location.protocol + "//" + window.location.host + '/h5';
      let pc = window.location.protocol + "//" + window.location.host;
      let current = window.location.origin + window.location.pathname;
      if(clientWidth > 1024){
        if(isH5){
          window.location.href = pc;
          //this.$router.push("/");
        }
      }else {
        if(!isH5){
          window.location.href = h5;
          //this.$router.push("/h5");
        }
      }
    },
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 15px;
}
body {
  margin: 0 !important;
}
</style>
